"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _logo = _interopRequireDefault(require("./logo.scss"));

var _logo2 = _interopRequireDefault(require("../../assets/logo.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Logo = function Logo(_ref) {
  var src = _ref.src;
  return _react["default"].createElement("a", {
    className: _logo["default"]['logo'],
    href: "#/"
  }, _react["default"].createElement("span", _extends({
    className: _logo["default"]['image']
  }, {
    style: {
      backgroundImage: "url(".concat(src || _logo2["default"], ")")
    }
  })));
};

Logo.propTypes = {};
Logo.defaultProps = {};
var _default = Logo;
exports["default"] = _default;